import { useEffect, useState } from "react";
import { CardTaps } from "../../../../../theme/Component/CardTaps";

import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { PersonalAccountData } from "../../../../../../portal/componets/pages/IndexPage/Components/PersonarDataUser/PersonalAccountData";
import { Alert } from "../../../../../theme/Component/Alert";
interface Props {
    requestBean: any;
    props: any;
}


export const PersonalInfoAfiliates = ({ requestBean, props }: Props) => {


    useEffect(() => {
        setTaps([
            { id: 0, name: 'Deudor', disable: false },
            { id: 1, name: 'Codeudor', disable: !(props.RequiresCodebtor ? true : false) },
        ])
    }, [props])

    const [taps, setTaps] = useState<any[]>([
        { id: 0, name: 'Deudor', disable: false },
        { id: 1, name: 'Codeudor', disable: false },
    ])

    const [indexTap, setIndexTap] = useState(0);

    return (
        <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap} >
            {indexTap === 0 &&
                <div className="row">
                    <div className="col-md-12">
                        <PersonalAccountData _PayrollType={props.IDCajaNominadora} _LoanLine={props.IDLoanLine} idAffiliate={props.IDAccount} type={[100, 101, 102]} />
                    </div>
                </div>
            }
            {indexTap === 1 &&
                <div className="row">
                    {props.IDAccountCodeuda ?
                        <div className="col-md-12">
                            <PersonalAccountData idAffiliate={props.IDAccountCodeuda} type={[100, 101, 102]} />
                        </div>
                        :
                        <Alert children={`No Presenta Codeudor`} clase="warning text-center" />}
                </div>
            }
        </CardTaps>
    )
}